import React, { useCallback } from "react";
import { EmbedProviderProps } from "./EmbedProviders";
import { ensureScriptTag } from "./tagManager";

// Module-level state: no custom globals on `window`
let contriblyScriptLoading = false;
let contriblyScriptLoaded = false;
const contriblyPending = new Set<HTMLDivElement>();


function initIfPossible(el: HTMLDivElement | null) {
  if (!el || !el.isConnected) return;
  const setup = (window as any).setupContriblyContributeWiget;
  if (setup) {
    try {
      console.info('[ContriblyContributeV2] Initializing element');
      setup(el);
    } catch (e) {
      console.error('[ContriblyContributeV2] Error during vendor setup', e);
    }
  } else {
    console.info('[ContriblyContributeV2] Vendor setup not ready yet; queueing element');
    contriblyPending.add(el);
  }
}

function loadContriblyScriptOnce() {
  if (contriblyScriptLoaded || contriblyScriptLoading) return;
  contriblyScriptLoading = true;

  const src = (window as any).contriblyContributeScriptUrl ||
    "https://contribly-widgets.s3.eu-west-1.amazonaws.com/contribute/contribute-tickaroo.js";

  console.info('[ContriblyContributeV2] Loading script', src);

  ensureScriptTag({
    src,
    async: true,
    onload: () => {
      contriblyScriptLoaded = true;
      contriblyScriptLoading = false;
      console.info('[ContriblyContributeV2] Script loaded');
      const pendingCount = contriblyPending.size;
      if (pendingCount > 0) {
        console.info('[ContriblyContributeV2] Initializing queued elements', pendingCount);
      }
      contriblyPending.forEach((node) => initIfPossible(node));
      contriblyPending.clear();
    },
    onerror: (e: any) => {
      contriblyScriptLoading = false;
      console.error('[ContriblyContributeV2] Failed to load script', src, e);
      // Optional: retry/backoff could be added here
    },
  } as any);
}

export function ContriblyContributeV2({ oembed }: EmbedProviderProps) {
  const ref = useCallback((el: HTMLDivElement | null) => {
    if (!el) return; // nothing to do on unmount

    // Try immediate init; if not possible, queue and ensure script loading
    initIfPossible(el);
    loadContriblyScriptOnce();
  }, []);

  return (
    <div
      className="tik4-we-contribly-contribute"
      ref={ref}
      dangerouslySetInnerHTML={{ __html: oembed.html || "" }}
    />
  );
}

export default ContriblyContributeV2
